var _style, _polygon, _polygon2, _polygon3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPinkRectangular(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 40.9 56.2",
    style: {
      enableBackground: "new 0 0 40.9 56.2"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:url(#SVGID_1_);}\n\t.st1{fill:url(#SVGID_2_);}\n\t.st2{fill:url(#SVGID_3_);}\n")), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 3.3513,
    y1: 17.7915,
    x2: 30.1218,
    y2: 7.1432
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#250C57"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08043665,
    style: {
      stopColor: "#401965"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2091,
    style: {
      stopColor: "#652B79"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.344,
    style: {
      stopColor: "#843A89"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4847,
    style: {
      stopColor: "#9C4596"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6338,
    style: {
      stopColor: "#AD4E9F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7967,
    style: {
      stopColor: "#B752A4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#BA54A6"
    }
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "0,10.7 22.2,18.7 28.8,0 "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 29.2333,
    y1: 18.8748,
    x2: 55.9713,
    y2: 87.0121
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF85CE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09800994,
    style: {
      stopColor: "#FF9DD9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2506,
    style: {
      stopColor: "#FFBBE6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4113,
    style: {
      stopColor: "#FFD3F1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5815,
    style: {
      stopColor: "#FFE4F8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7677,
    style: {
      stopColor: "#FFEEFD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFF1FE"
    }
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "40.9,56.2 22.2,18.7 28.8,0 "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 4.8198,
    y1: 6.6371,
    x2: 44.5559,
    y2: 57.7477
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#552676"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.009448886,
    style: {
      stopColor: "#592877"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1276,
    style: {
      stopColor: "#853D86"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2511,
    style: {
      stopColor: "#AA5092"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3789,
    style: {
      stopColor: "#C95F9C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5121,
    style: {
      stopColor: "#E16AA4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6532,
    style: {
      stopColor: "#F273AA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8075,
    style: {
      stopColor: "#FC77AD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF79AE"
    }
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "0,10.7 22.2,18.7 40.9,56.2 "
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPinkRectangular);
export default __webpack_public_path__ + "static/media/pink-rectangular.d4822fee47230de4364123b484343445.svg";
export { ForwardRef as ReactComponent };